<template>
  <div class="content">
    <div class="container-fluid">
      <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
        <vs-tabs>
          <vs-tab label="Lista de Comprobantes">
            <div class="con-tab-ejemplo">
              <div class="row">
                <div class="col-12">
                  <template class="header">
                    <div class="row">
                      <div class="col-xl-2 col-md-3"><vs-input style="height: auto !important;" type="date"
                          label="Inicio" v-model="inicio" /></div>
                      <div class="col-xl-2 col-md-3"><vs-input style="height: auto !important;" type="date" label="Fin"
                          class="inputx" v-model="fin" /></div>
                      <div v-if="optionsDependence.length > 1" class="col-xl-2 col-md-3" style="align-self: flex-end;">
                        <vs-select autocomplete class="selectExample" label="Dependencia" placeholder="Seleccionar"
                          v-model="dependence">
                          <vs-select-item :key="index" :value="item.value" :text="item.text"
                            v-for="item, index in optionsDependence" />
                        </vs-select>
                      </div>
                      <div class="col-xl-2 col-md-3" style="align-self: flex-end;">
                        <vs-select class="selectExample" label="Estado" placeholder="Seleccionar" v-model="filter">
                          <vs-select-item :key="index" :value="item.value" :text="item.text"
                            v-for="item, index in options2" />
                        </vs-select>
                      </div>
                      <div style="align-self: flex-end;" class="col-xl-2 col-md-3">
                        <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                          @click="getListDateVouchers()" color="primary" type="filled">Consultar</vs-button>
                      </div>
                    </div>
                  </template>
                  <table1 @functionComponentEdit="formEditVoucher" @functionComponentDownload="downloadVoucher"
                    style="margin-left: -15px;" class="table-hover table-striped" :columns="table1.columns"
                    :data="table1.data">
                  </table1>
                </div>
              </div>
            </div>
            <vs-popup classContent="popup-example" title="Comprobante" :active.sync="activatePopupEdit">
              <div class="row">
                <div style="text-align: center; margin-left: 15px; overflow: overlay; max-height: 20rem;">
                  <table>
                    <th>N° Ticket</th>
                    <th></th>
                    <th>Dependencia</th>
                    <th></th>
                    <th>Pago</th>
                    <th></th>
                    <th>Estado</th>
                    <th></th>
                    <th>Valor</th>
                    <tr v-for="(tr, index) in formEdit.tickets">
                      <td>
                        <p class="font-medium">{{ tr.order_number }}</p>
                      </td>
                      <td></td>
                      <td>
                        <p class="font-medium">{{ tr.dependence }}</p>
                      </td>
                      <td></td>
                      <td>
                        <p class="font-medium">{{ tr.method_payment }}</p>
                      </td>
                      <td></td>
                      <td>
                        <p class="font-medium" v-if="tr.status == 1">Creada</p>
                        <p class="font-medium" v-if="tr.status == 2">En Ejecución</p>
                        <p class="font-medium" v-if="tr.status == 3">Finalizada</p>
                        <p class="font-medium" v-if="tr.status == 4">Cancelada</p>

                      </td>
                      <td></td>
                      <td>
                        <p class="font-medium">${{ new Intl.NumberFormat("de-DE").format(parseFloat(tr.total)) }}</p>
                      </td>
                    </tr>
                    <tr style="padding-top: 10px;">
                      <td style="padding-top: 10px;"></td>
                      <td></td>
                      <td style="padding-top: 10px;"></td>
                      <td></td>
                      <td style="padding-top: 10px;"></td>
                      <td></td>
                      <td style="padding-top: 10px;">
                        <p style="font-weight: bold;">Total:</p>
                      </td>
                      <td></td>
                      <td style="padding-top: 10px;">
                        <p style="font-weight: bold;">${{ new
                          Intl.NumberFormat("de-DE").format(parseFloat(formEdit.total))}}</p>
                      </td>
                    </tr>
                  </table>
                </div>
                <hr><br>
                <div class="col-xl-4 col-md-4">
                  <vs-input label="Nombre" class="inputx" placeholder="Nombre" v-model="formEdit.name_user" />
                </div>
                <div class="col-xl-4 col-md-4">
                  <vs-select disabled class="selectExample" label="Dependencia" placeholder="Seleccionar"
                    v-model="formEdit.name_dependence">
                    <vs-select-item :key="index" :value="item.value" :text="item.text"
                      v-for="item, index in optionsDependence" />
                  </vs-select>
                </div>
                <!--<div class="col-xl-4 col-md-4">
                  <vs-input label="Centro de Costo" class="inputx" placeholder="Centro de Costo" v-model="formEdit.name_cost_center" disabled/>
                </div>-->
                <div class="col-xl-4 col-md-4">
                  <vs-input label="Observaciones" class="inputx" placeholder="Observaciones"
                    v-model="formEdit.observations" />
                </div>
                <div class="col-xl-4 col-md-4">
                  <vs-select class="selectExample" label="Estado" placeholder="Seleccionar" v-model="formEdit.status">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options3" />
                  </vs-select>
                </div>
                <div style="align-self: flex-end;" class="col-xl-4 col-md-4">
                  <button style="border: none; background-color: #0d6efd; width: 100%;"
                    class="btn btn-info btn-fill float-right" @click.prevent="editVoucher()">
                    Editar</button>
                </div>
              </div>
            </vs-popup>
          </vs-tab>
          <vs-tab label="Crear Comprobante">
            <div class="con-tab-ejemplo">
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <!--<div class="col-xl-2 col-md-3" style="align-self: flex-end;">
                      <vs-select class="selectExample" label="Centro de Costo" placeholder="Seleccionar" v-model="costCenter">
                        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in optionsCostCenter" />
                      </vs-select>
                    </div>-->
                    <div class="col-xl-2 col-md-3"><vs-input style="height: auto !important;" type="date" label="Inicio"
                        v-model="inicio" /></div>
                    <div class="col-xl-2 col-md-3"><vs-input style="height: auto !important;" type="date" label="Fin"
                        class="inputx" v-model="fin" /></div>
                    <div class="col-xl-2 col-md-3" style="align-self: flex-end;">
                      <vs-select autocomplete class="selectExample" label="Dependencia" placeholder="Seleccionar"
                        v-model="dependence">
                        <vs-select-item :key="index" :value="item.value" :text="item.text"
                          v-for="item, index in optionsDependence" />
                      </vs-select>
                    </div>

                    <div style="align-self: flex-end;" class="col-xl-2 col-md-3">
                      <!--<vs-button style="height: auto !important; font-size: 1rem; width: auto;" @click="getListTicketsByCostCenter()" color="primary" type="filled">Consultar</vs-button>-->
                      <vs-button style="height: auto !important; font-size: 1rem; width: auto;"
                        @click="getListTicketsByDependence()" color="primary" type="filled">Consultar</vs-button>
                    </div>
                  </div>
                </div>
              </div>
              <div style="padding-top: 25px;" class="row" v-if="activateDiv">
                <div class="col-12">
                  <template class="header">
                    <div class="row" style="justify-content: space-between;">
                      <div>
                        <h4 style="margin-left: 15px!important;" class="card-title">Lista de Tickets</h4>
                      </div>
                      <div style="padding-right: 15px;">
                        <button style="border: none; background-color: #0d6efd;"
                          class="btn btn-info btn-fill float-right" @click.prevent="openCreateVoucherPopup()">
                          Crear Comprobante
                        </button>
                      </div>
                    </div>
                  </template>
                  <l-table2 @selectTickets="reloadTicketsSelect" style="margin-left: -15px;"
                    class="table-hover table-striped" :columns="table2.columns" :data="table2.data" ref="child">
                  </l-table2>
                </div>
              </div>
            </div>
            <vs-popup classContent="popup-example" title="Comprobante" :active.sync="activatePopup">
              <div class="row">
                <div style="text-align: center; margin-left: 15px; overflow: overlay; max-height: 20rem;">
                  <th>N° Ticket</th>
                  <th></th>
                  <th>Dependencia</th>
                  <th></th>
                  <th>Pago</th>
                  <th></th>
                  <th>Estado</th>
                  <th></th>
                  <th>Valor</th>
                  <tr v-for="(tr, index) in form.ticketsSelect">
                    <td>
                      <p class="font-medium">{{ tr.order_number }}</p>
                    </td>
                    <td></td>
                    <td>
                      <p class="font-medium">{{ tr.dependence }}</p>
                    </td>
                    <td></td>
                    <td>
                      <p class="font-medium">{{ tr.method_payment }}</p>
                    </td>
                    <td></td>
                    <td>
                      <p class="font-medium">{{ tr.estado }}</p>
                    </td>
                    <td></td>
                    <td>
                      <p class="font-medium">$ {{ new Intl.NumberFormat("de-DE").format(parseFloat(tr.total)) }}</p>
                    </td>
                  </tr>
                  <tr style="padding-top: 10px;">
                    <td style="padding-top: 10px;"></td>
                    <td></td>
                    <td style="padding-top: 10px;"></td>
                    <td></td>
                    <td style="padding-top: 10px;"></td>
                    <td></td>
                    <td style="padding-top: 10px;">
                      <p style="font-weight: bold;">Total:</p>
                    </td>
                    <td></td>
                    <td style="padding-top: 10px;">
                      <p style="font-weight: bold;">$ {{ new
                        Intl.NumberFormat("de-DE").format(parseFloat(form.totalVoucher))}}</p>
                    </td>
                  </tr>
                </div>
                <hr><br>
                <div class="col-xl-4 col-md-4">
                  <vs-input label="Nombre" class="inputx" placeholder="Nombre" v-model="form.name_user" />
                </div>
                <div class="col-xl-4 col-md-4">
                  <vs-select v-bind:disabled="dependence != 10" class="selectExample" label="Dependencia"
                    placeholder="Seleccionar" v-model="form.name_dependence">
                    <vs-select-item :key="index" :value="item.value" :text="item.text"
                      v-for="item, index in optionsDependence" />
                  </vs-select>
                </div>
                <!--<div class="col-xl-4 col-md-4">
                  <vs-input label="Centro de Costo" class="inputx" placeholder="Centro de Costo" v-model="form.name_cost_center" disabled/>
                </div>-->
                <div class="col-xl-4 col-md-4">
                  <vs-input label="Observaciones" class="inputx" placeholder="Observaciones"
                    v-model="form.observations" />
                </div>
                <div style="align-self: flex-end; padding-top: 15px;" class="col-xl-4 col-md-4">
                  <button style="border: none; background-color: #0d6efd; width: 100%;"
                    class="btn btn-info btn-fill float-right" @click.prevent="createVoucher()">
                    Insertar</button>
                </div>
              </div>
            </vs-popup>
          </vs-tab>
        </vs-tabs>
      </card>
    </div>
  </div>
</template>
<script>
import Table1 from 'src/components/TableTickets.vue'
import LTable2 from 'src/components/TableTicketsVouchers.vue'
import Card from 'src/components/Cards/Card.vue'
import Vue from 'vue'
import vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css'
import getSecret from '../helpers/get-secret';
const serverUrl = getSecret('SERVER_URL');

Vue.use(vuesax)
const tableColumns = ['Numero', 'Dependencia', 'Fecha', 'Estado', 'Valor']
const tableColumns1 = ['Numero', 'Dependencia', 'Conductor', 'Vehículo', 'Cliente', 'Valor', 'Estado', 'Fecha']
export default {
  components: {
    Table1,
    LTable2,
    Card
  },
  data() {
    return {
      inicio: null,
      fin: null,
      id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
      filter: 10,
      activateDiv: false,
      activatePopup: false,
      activatePopupEdit: false,
      costCenter: '',
      dependence: 10,
      counter: 0,
      optionsDependence: [{ text: 'Todos', value: 10 }],
      form: {
        ticketsSelect: [],
        totalVoucher: 0,
        name_cost_center: ' ',
        name_dependence: '',
        id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
      },
      formEdit: {
        name_user: '',
        name_dependence: '',
        name_cost_center: '',
        status: '',
        observations: '',
        id_voucher: '',
      },
      optionsCostCenter: [],
      options2: [
        { text: 'Todos', value: 10 },
        { text: 'Pendiente', value: 1 },
        { text: 'Aprobado', value: 2 },
        { text: 'Declinado', value: 3 }
      ],
      options3: [
        { text: 'Pendiente', value: 1 },
        { text: 'Aprobado', value: 2 },
        { text: 'Declinado', value: 3 }
      ],
      table1: {
        columns: [...tableColumns],
        data: []
      },
      table2: {
        columns: [...tableColumns1],
        data: []
      },
    }
  },
  methods: {
    downloadVoucher(item) {
      let url2 = serverUrl;
      let url3 = `${url2}/api/getViewVoucher/${item.id_voucher}`;
      window.open(url3, '_blank');
    },
    getListDateVouchers() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      this.axios.get(serverUrl + '/api/getListDateVouchers/' + this.id_company + '/' + this.inicio + '/' + this.fin + '/' + this.filter + '/' + this.dependence)
        .then(res => {
          if (res.data.status == 200) {
            this.table1.data = res.data.comprobantes;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Consulta realizada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.$vs.loading.close();
          } else {
            console.log('Error getListDateVouchers');
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log('Error getListDateVouchers');
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });
    },
    openCreateVoucherPopup() {
      this.form.totalVoucher = 0;
      this.form.ticketsSelect.forEach((d) => {
        this.form.totalVoucher += parseFloat(d.total);
      })
      this.activatePopup = true;
    },
    /*getListCostCenter(){
      this.axios.get('https://backtickets.isolutions.website/api/getListActiveCostCenter/'+this.id_company)
        .then(res => {
          if(res.data.status == 200){
            res.data.costCenters.forEach(detail => {
              this.costCenter={text:detail.name,value:detail.name};
              this.optionsCostCenter.push(this.costCenter);
            });
          }else {
            console.log('Error getListCostCenter');
          }
        })
        .catch(err => {
          console.log('Error getListCostCenter');
        });
    },*/
    getListDependence() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      this.axios.get(serverUrl + '/api/getListActiveDependence/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.dependences.forEach(detail => {
              this.dependenceOptions = { text: detail.name, value: detail.name };
              this.optionsDependence.push(this.dependenceOptions);
            });
          } else {
            console.log('Error getListDependence');
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          console.log('Error getListDependence');
          this.$vs.loading.close();
        });
    },
    /*getListTicketsByCostCenter(){
      this.axios.get('https://backtickets.isolutions.website/api/getListTicketsByCostCenter/'+this.costCenter)
        .then(res => {
          if(res.data.status == 200){
            this.table2.data=res.data.tickets;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Consulta realizada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.activateDiv=true;
            this.form.name_cost_center=this.costCenter;
          }else {
            console.log('Error getListTicketsDate');
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
          }
        })
        .catch(err => {
          console.log('Error getListTicketsDate');
          this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
        });
    },*/
    getListTicketsByDependence() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      this.axios.get(serverUrl + '/api/getListTicketsByDependence/' + this.dependence + '/' + this.id_company + '/' + this.inicio + '/' + this.fin)
        .then(res => {
          if (res.data.status == 200) {
            this.table2.data = res.data.tickets;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Consulta realizada con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.activateDiv = true;
            if (this.dependence == 10) {
              this.form.name_dependence = '';
            } else {
              this.form.name_dependence = this.dependence;
            }
            this.form.ticketsSelect = [];
            if (this.counter != 0) {
              const hijo = this.$refs.child;
              hijo.selectTicketsReload();
            } else {
              this.counter += 1;
            }
            this.$vs.loading.close();
          } else {
            console.log('Error getListTicketsDate');
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.form.ticketsSelect = [];
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log('Error getListTicketsDate:' + err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>al realizar la consulta.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.form.ticketsSelect = [];
          this.$vs.loading.close();
        });
    },
    reloadTicketsSelect(ticketsSelect) {
      this.form.ticketsSelect = ticketsSelect;
    },
    createVoucher() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      this.axios.post(serverUrl + '/api/createVoucher', this.form)
        .then(res => {
          this.activatePopup = false;
          if (res.data.status == 200) {
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Comprobante Creado con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.form.name_user = '';
            this.form.name_dependence = '';
            this.form.observations = '';
            //this.getListTicketsByCostCenter();
            this.getListTicketsByDependence();
            this.getListDateVouchers();
            this.$vs.loading.close();
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al crear el Comprobante.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          this.activatePopup = false;
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al crear Comprobante.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });
    },
    formEditVoucher(item) {
      this.formEdit.name_user = item.name_user;
      this.formEdit.name_dependence = item.name_dependence;
      this.formEdit.name_cost_center = item.name_cost_center;
      this.formEdit.status = item.status;
      this.formEdit.observations = item.observations;
      this.formEdit.id_voucher = item.id_voucher;
      this.formEdit.tickets = item.tickets;
      this.formEdit.total = item.total;
      this.activatePopupEdit = true;
    },
    editVoucher() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      this.axios.post(serverUrl + '/api/editVoucher', this.formEdit)
        .then(res => {
          this.activatePopupEdit = false;
          if (res.data.status == 200) {
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Comprobante Editado con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            })
            this.getListDateVouchers();
            this.$vs.loading.close();
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al Editar el Comprobante.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          this.activatePopupEdit = false;
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al Editar el Comprobante.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });
    },
    getListDependence() {
      this.axios.get(serverUrl + '/api/getListActiveDependence/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            res.data.dependences.forEach(detail => {
              this.dependenceOptions = { text: detail.name, value: detail.name };
              this.optionsDependence.push(this.dependenceOptions);
            });
          } else {
            console.log('Error getListDependence');
          }
        })
        .catch(err => {
          console.log('Error getListDependence');
        });
    },
  },
  created() {
    const date = new Date();
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const anio = date.getFullYear();
    this.inicio = `${anio}-${mes}-${dia}`;
    this.fin = `${anio}-${mes}-${dia}`;
  },
  mounted() {
    //this.getListDateVouchers();
    this.getListDependence();
  }
}
</script>
<style>
input {
  height: auto !important;
}

.card label {
  text-transform: none !important;
  ;
}

.vs-icon {
  font-size: medium;
}

.con-example-prompt {
  padding: 10px;
  padding-bottom: 0px;
}

.con-example-prompt .vs-input {
  width: 100%;
  margin-top: 10px;
}

.vs-button {
  width: auto !important;
  margin: 0 !important;
  height: auto !important;
  font-size: 1rem !important;
}
</style>
